import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Select } from "@/components/elements/Select";
import { Grid } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { TLearnerForm } from "@/features/learner/types/learnerForm";
import { LearnerFormTitle } from "@/features/learner/components/learner-form/LearnerFormTitle";
import { divider, text } from "@/theme/colors";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { getLearnerAccountStatusLabel } from "@/features/learner/utils/getLabels";
import { useEnum } from "@/api/services/global/enum";

type TLearnerStatusProps = {
  data?: Partial<TLearnerForm>;
};

export const LearnerStatusForm: FC<TLearnerStatusProps> = ({ data }) => {
  const { control } = useFormContext<TLearnerForm>();
  const { data: planStatusOptions } = useEnum("EPlanStatus");

  const accountStatusLabel = getLearnerAccountStatusLabel(data?.userId, data?.user?.activeStatus, data?.isArchive, data?.user?.isArchive);

  return (
    <InnerBox title={<LearnerFormTitle text="ステータス" />} showDivider={false} borderColor={divider.high}>
      <Grid container rowSpacing={2} columnSpacing={3}>
        <Grid item xs={6}>
          <FormField control={control} name="learnerPlan.planStatus" label="受験ステータス">
            <Select options={planStatusOptions} />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <ItemInfo
            label="学習者アカウント"
            value={accountStatusLabel}
            isShowDivider={false}
            color={text.primary}
          />
        </Grid>
      </Grid>
    </InnerBox>
  );
};
